import React, { useEffect, useState } from "react";
import { getUserProfile } from "../utilities/axios.utilities";

interface IProps {
  setIsShowLogout: () => void;
}

const Header: React.FC<IProps> = ({ setIsShowLogout }) => {
  const [isShowMobile, setShowMobile] = useState(false);

  let userInfoString = localStorage.getItem("user_info");
  const userInfo = userInfoString ? JSON.parse(userInfoString) : null;
  
  const [userProfile, setUserProfile] = useState<any>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getUserProfile();
        setUserProfile(data);
        localStorage.setItem("user_info", JSON.stringify({
          coins: data.coins,
          role: data.role,
          userName: data.username,
        }));
      } catch (err) {
        console.error("Error fetching user profile:", err);
      }
    };

    fetchProfile();
  }, []);

  const handleLogoutClick = () => {
    // On mobile, navbar menu has z-index higher than modal; close menu first.
    setShowMobile(false);
    setIsShowLogout();
  };


  return (
    <div className="w-full h-[80px]">
      <header className="menu-lobby py-3">
        <nav className="navbar navbar-expand-lg navbar-dark flex justify-around items-center">
          <a className="navbar-brand" href="/">
            <img className="!w-[280px]" src="/assets/logo.png" alt="logo" />
          </a>
          <div className="menu">
            <div
              className={
                isShowMobile
                  ? "menu_wrapper menu_wrapper_active"
                  : "menu_wrapper"
              }
            >
              {/* Nút đóng menu - chỉ hiển thị khi menu active */}
              {isShowMobile && (
                <div 
                  className="menu-close-btn"
                  onClick={() => setShowMobile(false)}
                >
                  ✕
                </div>
              )}
              
              <a href="/" className="menu-item btn-home">
                <p>
                  <img
                    className="header-icon-img"
                    src="/assets/home-icon.png"
                    alt="Trang chủ"
                  />
                  Trang chủ
                </p>
              </a>
              <div className="menu-item btn-user">
                <p>
                  <img
                    className="header-icon-img"
                    src="/assets/user-icon.png"
                    alt="User"
                  />
                  {userInfo?.userName}
                </p>
              </div>
              <div className="menu-item btn-credit2 btn-redeem">
                <p>
                  <img
                    className="header-icon-img"
                    src="/assets/coins-icon.png"
                    alt="Coins"
                  />
                  {userInfo?.coins}
                </p>
              </div>

              <div
                className="menu-item btn-logout"
                onClick={handleLogoutClick}
              >
                <p>Đăng xuất</p>
              </div>
            </div>
            {/* Mobile Menu - luôn hiển thị trên mobile */}
            <div className="block sm:hidden">
              <div
                className={`menu-icon ${isShowMobile ? 'change' : ''}`}
                onClick={() => setShowMobile(!isShowMobile)}
              >
                <div className="bar1" />
                <div className="bar2" />
                <div className="bar3" />
              </div>
            </div>
          </div>
        </nav>
      </header>
    </div>
  );
};

export default Header;
